module.exports = __webpack_public_path__ + "/images/cover-embarazada-posando-resp.5749737.jpg";